import type {MapCursor} from '@gaia/utils/gaia/useInteractionHandlers';

export const editingWaypoint = {
    getCursor: (interaction: EditingWaypointInteractionState): MapCursor => {
        if (interaction.subtype === 'hovering') {
            return 'grab';
        } else if (interaction.subtype === 'dragging') {
            return 'grabbing';
        } else {
            return 'default';
        }
    },

    onMouseDown: () => {},
    onMouseUp: () => {},
    onMouseMove: () => {},
    onMouseOut: () => {},
    onClick: () => {},
    onDblClick: () => {},
};
